import type * as React from 'react';

type UseKeyboardNavigationOptions = {
  /** HTML Selector to target */
  selector?: string;
};

type UseKeyboardNavigationReturn = {
  /** Keyboard event handler for the container */
  handleKeyDown: (e: React.KeyboardEvent<HTMLElement>) => void;
};

export const useKeyboardNavigation = ({
  selector = '[role="tab"]',
}: UseKeyboardNavigationOptions = {}): UseKeyboardNavigationReturn => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>): void => {
    const currentTarget = e.currentTarget;
    const tabs = Array.from(
      currentTarget.querySelectorAll<HTMLElement>(selector)
    );

    if (tabs.length === 0) {
      return;
    }

    const currentIndex = tabs.findIndex((tab) =>
      tab.contains(document.activeElement)
    );

    let targetIndex: number | null = null;

    switch (e.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        e.stopPropagation();
        targetIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
        break;

      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        e.stopPropagation();
        targetIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
        break;

      case 'Home':
        e.preventDefault();
        e.stopPropagation();
        targetIndex = 0;
        break;

      case 'End':
        e.preventDefault();
        e.stopPropagation();
        targetIndex = tabs.length - 1;
        break;

      default:
        return;
    }

    if (targetIndex !== null && tabs[targetIndex]) {
      tabs[targetIndex].focus();
    }
  };

  return {
    handleKeyDown,
  };
};
